import { COUNTRIES, CompanyTypes } from "@shared_packages/toolkit/types";
import {
  ISearchFieldConfig,
  SearchFieldType,
} from "../../../../components/advanced-search/AdvancedSearch.interface";

/** Advanced Search fields shared by the Companies and Managed companies lists. */

export const businessTypeField: ISearchFieldConfig = {
  type: SearchFieldType.DROPDOWN,
  label: "Business type",
  key: "type",
  dropdownValues: [
    { label: "All", value: "" },
    { label: "Sole trader", value: CompanyTypes.SOLE_TRADER },
    { label: "Company", value: CompanyTypes.COMPANY },
    { label: "Consumer", value: CompanyTypes.CONSUMER },
  ],
};

// ~250 entries, hence the type-to-filter dropdown rather than a plain one.
export const countryField: ISearchFieldConfig = {
  type: SearchFieldType.SEARCHABLE_DROPDOWN,
  label: "Country",
  key: "countryCode",
  dropdownValues: [
    { label: "All countries", value: "" },
    ...COUNTRIES.map((c) => ({ label: c.countryName, value: c.countryCode })),
  ],
};
